import {DefaultChildren} from '#/utils/utils';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {FunctionComponent} from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
    },
  },
});

export const WrappedQueryClientProvider: FunctionComponent<DefaultChildren> = ({children}) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
